import { LinkProps } from 'react-router-dom';
import { t } from 'i18n-js';

import StyledButton from '~/components/atoms/StyledButton';
import BottomSheetDialog, {
  TBottomSheetDialogProps,
} from '~/components/molecules/BottomSheetDialog';

import styles from './BottomSheetDialogTemplate.module.scss';

type TBottomSheetDialogTemplate = TBottomSheetDialogProps & {
  src: string;
  headlineTranslation: string;
  descriptionTranslation: string;
  buttonTranslation: string;
  to?: LinkProps['to'];
};

export default function BottomSheetDialogTemplate({
  header,
  src,
  headlineTranslation,
  descriptionTranslation,
  buttonTranslation,
  to,
  ...props
}: TBottomSheetDialogTemplate): JSX.Element {
  return (
    <BottomSheetDialog
      header={t(header)}
      renderFooter={({ closeDialog }) => {
        const buttonProps = to ? { to } : { onClick: closeDialog };
        return (
          <StyledButton
            className={styles.button}
            {...buttonProps}
          >
            {t(buttonTranslation)}
          </StyledButton>
        );
      }}
      shouldEmitSound
      contentClassName={styles.BottomSheetDialogTemplate}
      {...props}
    >
      <img
        alt=""
        src={src}
        className={styles.image}
      />
      <div className={styles.headline}>{t(headlineTranslation)}</div>
      <div className={styles.description}>{t(descriptionTranslation)}</div>
    </BottomSheetDialog>
  );
}
